import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  QrcodeOutlined,
  SearchOutlined,
  ReloadOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { apiCall } from "../../API/RestApi";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const { Text } = Typography;

function ListDrawCode() {
  const token = useSelector((state) => state.user.token);

  const [data, setData] = useState([]);
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const [textAlert, setTextAlert] = useState("");

  const [page, setPage] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const [form] = Form.useForm();

  const headers = {
    Authorization: "Bearer " + token,
  };

  const formatRupiah = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return `Rp ${Number(value).toLocaleString("id-ID")}`;
  };

  const getSettingName = (record) => {
    return (
      record.draw_setting?.name ||
      record.DrawSetting?.name ||
      record.setting?.name ||
      "-"
    );
  };

  const columns = [
    {
      title: "No",
      key: "no",
      width: 70,
      render: (text, record, index) =>
        (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
    },
    {
      title: (
        <Tooltip title="Kode unik yang akan diinput atau discan user. Satu kode hanya bisa diklaim satu kali.">
          Kode Draw <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "draw_code",
      key: "draw_code",
      render: (text) => <b>{text}</b>,
    },
    {
      title: (
        <Tooltip title="Setting menentukan minimal pembelian, jumlah spin per kelipatan, dan maksimal spin per kode.">
          Setting <InfoCircleOutlined />
        </Tooltip>
      ),
      key: "draw_setting",
      render: (_, record) => <Text>{getSettingName(record)}</Text>,
    },
    {
      title: (
        <Tooltip title="Total nominal pembelian customer. Spin dihitung dari total pembelian dibagi minimal pembelian pada setting.">
          Total Pembelian <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "total_purchase_amount",
      key: "total_purchase_amount",
      render: (text) => formatRupiah(text),
    },
    {
      title: (
        <Tooltip title="Jumlah spin yang akan masuk ke saldo user setelah kode diklaim.">
          Spin <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "spin_count",
      key: "spin_count",
      width: 90,
      render: (text) => <Tag color="purple">{text || 0}x</Tag>,
    },
    {
      title: (
        <Tooltip title="Link QR dapat digunakan untuk redirect user ke halaman claim kode. Klik input untuk select link.">
          Link QR <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "draw_code",
      key: "qr_link",
      render: (text) => (
        <Input
          readOnly
          value={`${window.location.origin}/draw/${text}`}
          style={{ width: 260 }}
          onClick={(e) => e.target.select()}
        />
      ),
    },
    {
      title: (
        <Tooltip title="Unused: belum diklaim. Used: sudah diklaim user. Expired: masa berlaku habis.">
          Status <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (text) => {
        if (text === "unused") return <Tag color="blue">Unused</Tag>;
        if (text === "used") return <Tag color="green">Used</Tag>;
        if (text === "expired") return <Tag color="red">Expired</Tag>;
        return <Tag>{text}</Tag>;
      },
    },
    {
      title: (
        <Tooltip title="User ID akan terisi saat kode sudah diklaim oleh user.">
          User ID <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "users_id",
      key: "users_id",
      width: 100,
      render: (text) => text || "-",
    },
    {
      title: (
        <Tooltip title="Tanggal ketika kode berhasil diklaim user.">
          Used At <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "used_at",
      key: "used_at",
      width: 180,
      render: (text) => (text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: (
        <Tooltip title="Tanggal batas akhir kode bisa diklaim. Kosong berarti tidak ada masa expired.">
          Expired At <InfoCircleOutlined />
        </Tooltip>
      ),
      dataIndex: "expired_at",
      key: "expired_at",
      width: 180,
      render: (text) => (text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: "right",
      render: (_, record) => (
        <Space>
          <Tooltip title="Lihat detail draw code">
            <Button onClick={() => openDetail(record)} icon={<EyeOutlined />} />
          </Tooltip>

          <Tooltip title="Ubah data draw code">
            <Button
              type="primary"
              onClick={() => openModal("edit", record)}
              icon={<EditOutlined />}
              disabled={record.status !== "unused"}
            />
          </Tooltip>

          <Tooltip title="Hapus draw code">
            <Button
              danger
              type="primary"
              onClick={() => modalDeleteData(record)}
              icon={<DeleteOutlined />}
              disabled={record.status !== "unused"}
            />
          </Tooltip>
        </Space>
      ),
    }
  ];

  useEffect(() => {
    getData();
  }, [JSON.stringify(page), search, status]);

  useEffect(() => {
    getSettings();
  }, []);

  const getData = () => {
    setLoading(true);

    let url =
      "/draw-code?search=" +
      encodeURIComponent(search) +
      "&page=" +
      page.pagination.current +
      "&limit=" +
      page.pagination.pageSize;

    if (status !== "") {
      url += "&status=" + status;
    }

    apiCall({
      method: "GET",
      url,
      data: {
        headers,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.rows || []);
          setPage({
            ...page,
            pagination: {
              ...page.pagination,
              total: res.data.count || 0,
            },
          });
        }

        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const getSettings = () => {
    apiCall({
      method: "GET",
      url: "/draw-setting?status=active&page=1&limit=100",
      data: {
        headers,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setSettings(res.data.rows || []);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const openModal = (type, record = null) => {
    setDataModal(null);
    form.resetFields();

    if (type === "edit") {
      setDataModal(record);

      form.setFieldsValue({
        draw_setting_id: record.draw_setting_id,
        draw_code: record.draw_code,
        total_purchase_amount: Number(record.total_purchase_amount || 0),
        status: record.status,
        expired_at: record.expired_at ? dayjs(record.expired_at) : null,
      });
    } else {
      form.setFieldsValue({
        status: "unused",
        total_purchase_amount: 0,
      });
    }

    setIsModal(true);
  };

  const closeModal = () => {
    setIsModal(false);
    setDataModal(null);
    form.resetFields();
  };

  const modalDeleteData = (record) => {
    Modal.confirm({
      title: "Hapus Draw Code",
      content: `Anda ingin menghapus kode "${record.draw_code}"? Kode hanya bisa dihapus jika belum digunakan.`,
      okText: "Hapus",
      cancelText: "Batal",
      okButtonProps: {
        danger: true,
      },
      onOk: () => postApi("DELETE", record),
    });
  };

  const postApi = (method, values) => {
    setLoading(true);

    let url = "/draw-code";

    if (method === "PUT") {
      url = "/draw-code/" + dataModal.draw_code_id;
    }

    if (method === "DELETE") {
      url = "/draw-code/" + values.draw_code_id;
    }

    apiCall({
      method,
      url,
      data: {
        data: values,
        headers,
      },
    })
      .then((res) => {
        setLoading(false);

        if (res.status === 200) {
          setIsAlert(true);
          setTextAlert(res.message || "Berhasil menyimpan data");
          closeModal();
          getData();
        } else {
          Modal.error({
            title: "Gagal",
            content: res.message,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    const payload = {
      draw_setting_id: values.draw_setting_id,
      draw_code: values.draw_code,
      total_purchase_amount: values.total_purchase_amount || 0,
      expired_at: values.expired_at
        ? values.expired_at.format("YYYY-MM-DD HH:mm:ss")
        : null,
    };

    if (dataModal) {
      postApi("PUT", payload);
    } else {
      postApi("POST", payload);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPage({
      pagination,
      filters,
      ...sorter,
    });
  };

  const searchData = (value) => {
    setSearch(value);
    setPage({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
  };

  const generateCode = () => {
    const code =
      "BOLDE-" +
      Math.random().toString(36).substring(2, 8).toUpperCase() +
      "-" +
      Date.now().toString().slice(-4);

    form.setFieldsValue({
      draw_code: code,
      status: "unused",
    });
  };

  const calculatePreviewSpin = () => {
    const values = form.getFieldsValue();
    const selectedSetting = settings.find(
      (item) => item.draw_setting_id === values.draw_setting_id
    );

    if (!selectedSetting) return 0;

    let spin =
      Math.floor(
        Number(values.total_purchase_amount || 0) /
        Number(selectedSetting.min_purchase_amount || 1)
      ) * Number(selectedSetting.spin_per_amount || 1);

    if (selectedSetting.max_spin_per_code) {
      spin = Math.min(spin, Number(selectedSetting.max_spin_per_code));
    }

    return spin;
  };

  const openDetail = (record) => {
    const setting =
      record.draw_setting ||
      record.DrawSetting ||
      record.setting ||
      null;

    Modal.info({
      title: "Detail Draw Code",
      width: 620,
      content: (
        <div style={{ marginTop: 12 }}>
          <p>
            <b>Kode Draw:</b> {record.draw_code}
          </p>

          <p>
            <b>Status:</b> {record.status}
          </p>

          <p>
            <b>Setting:</b> {setting?.name || "-"}
          </p>

          <p>
            <b>Total Pembelian:</b>{" "}
            {formatRupiah(record.total_purchase_amount)}
          </p>

          <p>
            <b>Spin Count:</b> {record.spin_count || 0}x
          </p>

          <p>
            <b>User ID:</b> {record.users_id || "-"}
          </p>

          <p>
            <b>Used At:</b>{" "}
            {record.used_at
              ? dayjs(record.used_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </p>

          <p>
            <b>Expired At:</b>{" "}
            {record.expired_at
              ? dayjs(record.expired_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </p>

          <p>
            <b>QR Link:</b>
            <br />
            <Input
              readOnly
              value={`${window.location.origin}/draw/${record.draw_code}`}
              onClick={(e) => e.target.select()}
            />
          </p>

          <hr />

          <p>
            <b>Aturan:</b>
            <br />
            Kode hanya bisa diklaim satu kali. Setelah diklaim, spin akan masuk ke saldo user.
          </p>

          <p>
            <b>Rumus Spin:</b>
            <br />
            floor(total pembelian / min pembelian) × spin per amount
          </p>
        </div>
      ),
    });
  };

  return (
    <>
      {isAlert && (
        <Alert
          message={textAlert}
          type="success"
          banner
          closable
          afterClose={() => setIsAlert(false)}
        />
      )}

      <Card
        title={
          <Space>
            <QrcodeOutlined />
            <b>Master Draw Code</b>
            <Tooltip title="Master kode undian. Kode dibuat dari transaksi pembelian, lalu user bisa claim kode untuk menambah saldo spin. Satu kode hanya bisa diklaim satu kali.">
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
        }
        extra={
          <Space>
            <Tooltip title="Refresh data draw code">
              <Button onClick={getData}>
                <ReloadOutlined /> Refresh
              </Button>
            </Tooltip>

            <Tooltip title="Tambah kode draw baru berdasarkan nominal pembelian dan setting spin aktif.">
              <Button type="primary" onClick={() => openModal("add")}>
                <PlusOutlined /> Tambah Draw Code
              </Button>
            </Tooltip>
          </Space>
        }
      >
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} md={10}>
            <Tooltip title="Cari berdasarkan kode draw. Tekan enter atau klik tombol search.">
              <Search
                placeholder="Cari kode draw..."
                allowClear
                enterButton={<SearchOutlined />}
                onSearch={searchData}
              />
            </Tooltip>
          </Col>

          <Col xs={24} md={6}>
            <Tooltip title="Filter status kode: unused, used, atau expired.">
              <Select
                allowClear
                placeholder="Filter status"
                style={{ width: "100%" }}
                onChange={(value) => {
                  setStatus(value || "");
                  setPage({
                    pagination: {
                      current: 1,
                      pageSize: 10,
                    },
                  });
                }}
                options={[
                  { value: "unused", label: "Unused" },
                  { value: "used", label: "Used" },
                  { value: "expired", label: "Expired" },
                ]}
              />
            </Tooltip>
          </Col>
        </Row>

        <Table
          rowKey="draw_code_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={page.pagination}
          onChange={handleTableChange}
          scroll={{ x: 1600 }}
        />
      </Card>

      <Modal
        title={
          <Space>
            {dataModal ? "Ubah Draw Code" : "Tambah Draw Code"}
            <Tooltip title="Draw code akan menghasilkan jumlah spin berdasarkan total pembelian dan setting yang dipilih.">
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
        }
        open={isModal}
        onOk={form.submit}
        onCancel={closeModal}
        okText="Simpan"
        cancelText="Batal"
        width={760}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="draw_setting_id"
                label={
                  <Tooltip title="Pilih setting yang menentukan minimal pembelian dan rumus jumlah spin.">
                    Setting Spin <InfoCircleOutlined />
                  </Tooltip>
                }
                rules={[
                  { required: true, message: "Setting spin wajib dipilih!" },
                ]}
              >
                <Select
                  placeholder="Pilih setting spin"
                  options={settings.map((item) => ({
                    value: item.draw_setting_id,
                    label: `${item.name} - Min ${formatRupiah(
                      item.min_purchase_amount
                    )}`,
                  }))}
                  onChange={() => form.validateFields(["total_purchase_amount"])}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="draw_code"
                label={
                  <Tooltip title="Kode unik untuk customer. Satu kode hanya bisa diklaim satu kali.">
                    Kode Draw <InfoCircleOutlined />
                  </Tooltip>
                }
                rules={[
                  { required: true, message: "Kode draw wajib diisi!" },
                  { min: 4, message: "Kode draw minimal 4 karakter!" },
                ]}
              >
                <Input
                  placeholder="Contoh: BOLDE-ABC123"
                  addonAfter={
                    <Tooltip title="Generate kode otomatis">
                      <Button type="link" size="small" onClick={generateCode}>
                        Generate
                      </Button>
                    </Tooltip>
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="total_purchase_amount"
                label={
                  <Tooltip title="Nominal pembelian customer. Contoh: 920000 dengan min pembelian 300000 akan menghasilkan 3 spin.">
                    Total Pembelian <InfoCircleOutlined />
                  </Tooltip>
                }
                rules={[
                  {
                    required: true,
                    message: "Total pembelian wajib diisi!",
                  },
                  {
                    type: "number",
                    min: 0,
                    message: "Total pembelian tidak boleh minus!",
                  },
                  {
                    validator: (_, value) => {
                      const values = form.getFieldsValue();
                      const selectedSetting = settings.find(
                        (item) =>
                          item.draw_setting_id === values.draw_setting_id
                      );

                      if (!selectedSetting || value === undefined || value === null) {
                        return Promise.resolve();
                      }

                      if (
                        Number(value) <
                        Number(selectedSetting.min_purchase_amount)
                      ) {
                        return Promise.reject(
                          new Error(
                            `Minimal pembelian ${formatRupiah(
                              selectedSetting.min_purchase_amount
                            )}`
                          )
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  placeholder="Contoh: 920000"
                  formatter={(value) =>
                    `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  parser={(value) => value.replace(/Rp\s?|(\.*)/g, "")}
                  onChange={() => {
                    form.validateFields(["total_purchase_amount"]);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label={
                  <Tooltip title="Preview jumlah spin. Nilai final tetap dihitung ulang oleh backend saat data disimpan.">
                    Preview Spin <InfoCircleOutlined />
                  </Tooltip>
                }
              >
                <Input readOnly value={`${calculatePreviewSpin()}x spin`} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="expired_at"
                label={
                  <Tooltip title="Tanggal expired kode. Jika dikosongkan, kode tidak memiliki batas expired.">
                    Expired At <InfoCircleOutlined />
                  </Tooltip>
                }
              >
                <DatePicker
                  showTime
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="status"
                label={
                  <Tooltip title="Status otomatis. Kode baru selalu unused. Used akan terisi setelah user claim.">
                    Status <InfoCircleOutlined />
                  </Tooltip>
                }
                initialValue="unused"
              >
                <Select
                  disabled
                  options={[
                    { value: "unused", label: "Unused" },
                    { value: "used", label: "Used" },
                    { value: "expired", label: "Expired" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default ListDrawCode;